module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "aria-label": "38",
      "epub:type": "pagebreak",
      "id": "page38",
      "role": "doc-pagebreak"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "chapter-number-only",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left"
  }, [_vm._v("“You okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy turned to face Bobby, her hands still moving, massaging the dough. “Huh? I’m fine. Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You’re working about twice normal speed. And you’re singing.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What? I’m not singing, Bobby.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Humming. Whatever. You never hum. You’re always … you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy’s hands stilled. “I’m always "), _c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v("what")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Bobby looked at her a long moment, then turned his attention to the oven on his left. “Nothing. Forget it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy tossed the dough onto the counter and rubbed the flour from her hands as she advanced on Bobby. “No, it’s not nothing. What did you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He shrugged. “Well … like there’s a black cloud hanging over you.” He pulled open the oven door. “You’re kind of, I dunno, depressed.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy frowned. “There’s more to it than that.” She headed back to her workstation. “And I wasn’t humming.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That song from"), _c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v(" Something Rotten")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy had to fight to keep herself from smiling.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "39",
      "epub:type": "pagebreak",
      "id": "page39",
      "role": "doc-pagebreak"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yeah, I see that grin. I’m right, aren’t I?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Bobby laughed boisterously. “So … what, did you meet someone?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v("I did, but it’s not what you’re thinking. ")]), _vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“But something happened at lunch. You were real quiet this morning, you leave for a half hour and you’re humming Broadway tunes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy punched her fist into the mound—one of the things she enjoyed about her job. Controlled aggression. “Whatever.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yeah,” Bobby said with another laugh. “Whatever. But whoever it is, I’m happy for you. Even if I wanted it to be me. I’m happy for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I didn’t meet a guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Hmm. Then I still got a chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("“You know, Bobby, that’s true. You do. Just like winning the lottery.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03628d3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781504095785-5.vue
// module id = 90
// module chunks = 0